import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { authInterceptor } from '@/core/interceptors/auth-interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            appRoutes,
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
            withEnabledBlockingInitialNavigation()
        ),
        provideHttpClient(
            withFetch(),
            withInterceptors([authInterceptor]) // ✅ درست و کامل
        ),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } },
            // به‌صورت پیش‌فرض فهرست‌های بازشونده (Select / MultiSelect / ...) با هر اسکرول صفحه یا دیالوگ بسته می‌شوند؛
            // در نتیجه وقتی کاربر برای دیدن گزینه‌ها اسکرول می‌کند فهرست بسته می‌شد. بستن با اسکرول غیرفعال است.
            overlayOptions: {
                listener: (_event: Event, options?: { type?: string; valid?: boolean }) =>
                    options?.type === 'scroll' ? false : options?.valid
            },
            license: 'eyJpZCI6IjFhZmE5NjA2LTBkNmQtNDg5Zi1hMDA5LTRhZTJiNzg1MjllYSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODc5NjAyNDMsImV4cCI6MTgxOTQ5NjI0M30.gGyearnVY22u-20S_XycuQJcdybqiZx8yMkETXBiJ6OeTS3JZ3YWrISSJYcIENSE-LPqtGDwYJGu7WJJX6pFDg'
        })
    ]
};
